<div class="form-header">
    <img [src]="institute?.logo || defaultLogo" alt="Institute Logo" class="institute-logo">
    <h1>{{ institute?.name }}</h1>
    <div class="divider"></div>
    <h2>Student Admission Form</h2>
    <p>Please fill in the details carefully. Fields marked <strong>*</strong> are mandatory.</p>
</div>
